/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import TextLink from "../../../../../components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "../../../../../components/TextLink/types";
import { ROUTES } from "../../../../../shared";

interface IEnquiryTextProps {
  primaryText: string;
  linkText: string;
  component?: any;
  to?: ROUTES;
  onClick?: () => void;
}

const EnquiryText = ({
  primaryText,
  linkText,
  ...props
}: IEnquiryTextProps) => {
  return (
    <div
      css={css({
        marginTop: "16px"
      })}
    >
      <Typography
        component="span"
        variant="body2Medium"
        sx={{ color: colors.textDark }}
      >
        {primaryText}&nbsp;
      </Typography>

      <TextLink {...props} size={TEXT_LINK_SIZES.Normal} underline="none">
        {linkText}
      </TextLink>
    </div>
  );
};

export default EnquiryText;
